import PropTypes from 'prop-types';
import { AlertCircle, CheckCircle, AlertTriangle, Info, X } from 'lucide-react';
import './Alert.css';

export default function Alert({
    type = 'info',
    title,
    children,
    dismissible = false,
    onDismiss,
    className = ''
}) {
    const icons = {
        success: CheckCircle,
        error: AlertCircle,
        warning: AlertTriangle,
        info: Info
    };

    const Icon = icons[type];

    return (
        <div className={`alert alert-${type} ${className}`}>
            <div className="alert-icon">
                <Icon size={20} />
            </div>
            <div className="alert-content">
                {title && <div className="alert-title">{title}</div>}
                <div className="alert-message">{children}</div>
            </div>
            {dismissible && (
                <button className="alert-dismiss" onClick={onDismiss}>
                    <X size={16} />
                </button>
            )}
        </div>
    );
}

Alert.propTypes = {
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    title: PropTypes.string,
    children: PropTypes.node,
    dismissible: PropTypes.bool,
    onDismiss: PropTypes.func,
    className: PropTypes.string
};
